export * from './exams.model';
export * from './exams.module';
export * from './exams.seed';
export * from './exams.types';
